var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderOpen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "folder-open"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.99947 9.3334L4.99947 7.40006C5.10818 7.18416 5.27355 7.00187 5.47787 6.8727C5.6822 6.74352 5.9178 6.67233 6.15947 6.66673H13.3328M13.3328 6.66673C13.5365 6.66637 13.7376 6.71269 13.9206 6.80212C14.1036 6.89155 14.2636 7.02172 14.3885 7.18264C14.5134 7.34356 14.5997 7.53095 14.6409 7.73043C14.6821 7.92991 14.6771 8.13618 14.6261 8.3334L13.5995 12.3334C13.5252 12.6211 13.3569 12.8758 13.1214 13.0569C12.8859 13.2381 12.5966 13.3354 12.2995 13.3334H2.66613C2.31251 13.3334 1.97337 13.1929 1.72332 12.9429C1.47328 12.6928 1.3328 12.3537 1.3328 12.0001V3.3334C1.3328 2.97978 1.47328 2.64064 1.72332 2.39059C1.97337 2.14054 2.31251 2.00006 2.66613 2.00006H5.26613C5.48912 1.99788 5.7091 2.05166 5.90593 2.15648C6.10276 2.2613 6.27016 2.41381 6.3928 2.60006L6.9328 3.40006C7.05421 3.58442 7.21948 3.73574 7.4138 3.84047C7.60812 3.94519 7.82539 4.00003 8.04613 4.00006H11.9995C12.3531 4.00006 12.6922 4.14054 12.9423 4.39059C13.1923 4.64064 13.3328 4.97978 13.3328 5.3334V6.66673Z",
    stroke: "#1B8C5A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpen);
export default __webpack_public_path__ + "static/media/folder-open.ef33f6ef7eb873176401a7c08e646a67.svg";
export { ForwardRef as ReactComponent };